import { bootstrapApplication } from '@angular/platform-browser';

import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { GtmService } from './app/core/services/gtm.service';

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(reg => console.log('[SW] Registrado com sucesso:', reg.scope))
      .catch(err => console.error('[SW] Falha no registro:', err))
  })
}

bootstrapApplication(AppComponent, appConfig)
  .then(ref => {
    const gtm = ref.injector.get(GtmService);
    gtm.init();
  })
  .catch(err => console.error(err));